import { render, staticRenderFns } from "./ProductsListTab.vue?vue&type=template&id=4e206b2a&scoped=true"
import script from "./ProductsListTab.vue?vue&type=script&lang=js"
export * from "./ProductsListTab.vue?vue&type=script&lang=js"
import style0 from "./ProductsListTab.vue?vue&type=style&index=0&id=4e206b2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e206b2a",
  null
  
)

export default component.exports